module.exports = __webpack_public_path__ + "img/check-input.6a6c0040.svg";